module.exports = __webpack_public_path__ + "static/media/gold-combo.3605639a.svg";